<div class="innerBanner" style="background-image: url('{{ termsOfUseDetails.bannerImage }}')" (click)="imageClick(0)">
  <div class="bannerText"></div>
</div>
<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<div class="container contentPanel">
  <nav aria-label="breadcrumb" class="breadcrumbTerms">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">{{ termsOfUseDetails.bannerTitle }}</li>
    </ol>
  </nav>
  <!-- <h1>{{ termsOfUseDetails.bannerTitle }}</h1> -->
  <div class="pageTitle">
    <!-- <p [innerHTML]="termsOfUseDetails.content"></p> -->
    <div class="termsOfUse" #termsOfUse></div>
    <div
      name="termly-embed"
      data-id="55abe8d0-377d-4329-8200-7eef9b825730"
      data-type="iframe"
      class="termsOfPolicyIframe"
    ></div>
  </div>
</div>
